export default __webpack_public_path__ + "assets/9f49f58ea9a0961427c5e84bac02c3a5.png";